'use strict';
const angular = require('angular');

export default angular.module('nodeApp.constants', [])
  .constant('appConfig', {})
  .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.ts